import { useId } from 'react';
import FormField, { FormFieldProps } from 'fe-design-base/atoms/FormField';
import TaxIdInput, { TaxIdInputProps } from 'fe-design-base/atoms/TaxIdInput';
import { Field, FormikValues, useFormikContext } from 'formik';

export type TaxIdFieldProps = Omit<FormFieldProps, 'children'> &
  Omit<TaxIdInputProps, 'value' | 'onChange'>;

const TaxIdField = ({
  name,
  label,
  inputId,
  width,
  onBlur,
  fullWidth,
  labelPosition,
  labelWidth,
  shrink,
  disabled,
  hasAsterisk,
  helperText,
  successText,
  ...inputProps
}: TaxIdFieldProps) => {
  const { touched, errors } = useFormikContext<FormikValues>();
  const error = touched?.[name] && errors?.[name] && !disabled;
  const fieldId = useId();

  const isRequired = hasAsterisk && !disabled && !inputProps.readOnly;

  return (
    <FormField
      label={label}
      name={name}
      inputId={inputId || fieldId}
      width={width}
      fullWidth={fullWidth}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      shrink={shrink}
      disabled={disabled}
      uxElement={inputProps.uxElement}
      hasAsterisk={hasAsterisk}
      helperText={helperText}
      successText={successText}
    >
      <Field
        as={TaxIdInput}
        name={name}
        id={inputId || fieldId}
        disabled={disabled}
        fullWidth={fullWidth}
        error={error}
        label={label}
        required={isRequired}
        {...inputProps}
        // Note: using onBlurCapture to avoid interfering with Formik handleBlur & validation
        onBlurCapture={onBlur}
      />
    </FormField>
  );
};

export default TaxIdField;
